import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header-area header-one">
      <div className="container">
        <div className="header-navigation">
          {/* Main Flex Container: Space between Logo (Left) and Nav/Actions (Right) */}
          <div className="nav-inner-menu d-flex justify-content-between align-items-center">
            
            {/* LEFT SIDE: Logo */}
            <div className="site-branding">
              <a href="/" className="brand-logo" style={{ textDecoration: 'none' }}>
                {/* Using the consistent logo path, adjust if specific mobile/desktop logos differ */}
                <img src="/images/fsl_logo.png" alt="Logo" style={{ height: '50px' }} />
                
              </a>
            </div>

            {/* RIGHT SIDE: Desktop Navigation & Buttons */}
            <div className="d-flex align-items-center">
              
              {/* Desktop Main Menu */}
              <nav className="main-menu d-none d-lg-block">
                <ul className="d-flex gap-4 list-unstyled mb-0">
                  <li className="menu-item">
                    <a href="/" style={{ textDecoration: 'none' }}>Home</a>
                  </li>
                  <li className="menu-item">
                    <a href="/about" style={{ textDecoration: 'none' }}>About Us</a>
                  </li>
                  <li className="menu-item">
                    <a href="/plans" style={{ textDecoration: 'none' }}>Plan</a>
                  </li>
                  <li className="menu-item">
                    <a href="/contact" style={{ textDecoration: 'none' }}>Contact</a>
                  </li>
                </ul>
              </nav>

              {/* Desktop Action Buttons */}
              <div className="header-buttons d-none d-lg-flex align-items-center gap-2 ms-4">
                <Link to="/login" className="theme-btn style-two" style={{ textDecoration: 'none' }}>Login</Link>
                <Link to="/get-started" className="theme-btn style-one" style={{ textDecoration: 'none' }}>Get Started</Link>
              </div>

              {/* Mobile Toggler (Hamburger) - Visible only on Mobile */}
              <div className="nav-right-item d-lg-none ms-3">
                <div 
                  className={`navbar-toggler ${isMenuOpen ? 'open' : ''}`} 
                  onClick={toggleMenu}
                  style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <span style={{ display: 'block', width: '25px', height: '3px', backgroundColor: '#333' }}></span>
                  <span style={{ display: 'block', width: '25px', height: '3px', backgroundColor: '#333' }}></span>
                  <span style={{ display: 'block', width: '25px', height: '3px', backgroundColor: '#333' }}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="mobile-menu-overlay d-lg-none">
          <div className="theme-nav-menu p-4 bg-white shadow">
            {/* Mobile Top Logo (Optional, can remove if redundant) */}
            <div className="theme-menu-top d-flex justify-content-between mb-4">
               {/* If you want a close button here, you can add it */}
            </div>

            {/* Mobile Links */}
            <nav className="main-menu-mobile">
              <ul className="list-unstyled">
                <li className="menu-item mb-3"><a href="/" onClick={toggleMenu} style={{ textDecoration: 'none', fontSize: '18px' }}>Home</a></li>
                <li className="menu-item mb-3"><a href="/about" onClick={toggleMenu} style={{ textDecoration: 'none', fontSize: '18px' }}>About Us</a></li>
                <li className="menu-item mb-3"><a href="/plans" onClick={toggleMenu} style={{ textDecoration: 'none', fontSize: '18px' }}>Plan</a></li>
                <li className="menu-item mb-3"><a href="/contact" onClick={toggleMenu} style={{ textDecoration: 'none', fontSize: '18px' }}>Contact</a></li>
              </ul>
            </nav>

            {/* Mobile Buttons */}
            <div className="theme-nav-button mt-4 d-flex flex-column gap-2">
              <Link to="/login" className="theme-btn style-two w-100 text-center" onClick={toggleMenu} style={{ textDecoration: 'none' }}>Login</Link>
              <Link to="/get-started" className="theme-btn style-one w-100 text-center" onClick={toggleMenu} style={{ textDecoration: 'none' }}>Get Started</Link>
            </div>

            {/* Mobile Socials */}
            <div className="theme-menu-bottom mt-5">
              <h5>Follow Us</h5>
              <ul className="social-link list-unstyled d-flex gap-3">
                <li><a href="/" style={{ textDecoration: 'none' }}><i className="fab fa-facebook-f"></i></a></li>
                <li><a href="/" style={{ textDecoration: 'none' }}><i className="fab fa-twitter"></i></a></li>
                <li><a href="/" style={{ textDecoration: 'none' }}><i className="fab fa-linkedin-in"></i></a></li>
                <li><a href="/" style={{ textDecoration: 'none' }}><i className="fab fa-youtube"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* CSS Styles */}
      <style>{`
        .header-area a,
        .header-area .theme-btn,
        .header-area .nav-link {
          text-decoration: none !important;
        }
        .header-area a:hover,
        .header-area .theme-btn:hover {
          text-decoration: none !important;
        }
        
        /* Optional: Add transition for smooth mobile menu appearance if desired */
        .mobile-menu-overlay {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          z-index: 999;
          background: white;
        }
      `}</style>
    </header>
  );
}

export default Header;